module.exports = __webpack_public_path__ + "Roboto-Regular.30799efa5bf74129468a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Regular.eot
// module id = 88
// module chunks = 2